// zustand
import { useDocumentStore, type Document } from "@/zustand/documentStore";

// ເອກະສານ
// ===== ແຜນດຳເນີນງານ =====
// * ແຜນດຳເນີນງານ : OPERATION_PLAN

// ===== ແຜນມອບພັນທະໃຫ້ລັດ =====
// * ລາຍງານແຜນມອບພັນທະອາກອນ : TAX_OBLIGATION_PLAN,
// * ລາຍງານແຜນມອບເງິນປັນຜົນ : DIVIDEND_DISTRIBUTION_PLAN

// ===== ລາຍງານການເງິນຂອງບໍລິສັດ =====
// * ລາຍງານຖານະການເງິນ-ຊັບສິນ : ASSET_REPORT,
// * ລາຍງານຖານະການເງິນ-ໜີ້ສິນ : DEBT_REPORT,
// * ລາຍງານກະແສເງິນສົດ-ຈັດຕາມແບບວິທີທາງກົງ : CASH_FLOW_REPORT,
// * ລາຍງານກະແສເງິນສົດ-ຈັດຕາມແບບວິທີທາງອ້ອມ : CASH_FLOW_REPORT,
// * ລາຍງານຜົນການດຳເນີນງານ : FINANCIAL_REPORT,
// * ລາຍງານສ່ວນປ່ຽນແປງທຶນເຈົ້າຂອງ : OWNER_EQUITY_CHANGE_REPORT,
// * ລາຍງານຊັບສິນຄົງທີ່ : FIX_ASSET_REPORT,
// * ບັນດາຕົວຊີ້ວັດທີ່ຈະນຳໃຊ້ຂໍ້ມູນ : INDICATOR_REPORT,

// ===== ລາຍງານມອບພັນທະໃຫ້ລັດ =====
// * ລາຍງານມອບພັນທະອາກອນ : TAX_OBLIGATION_REPORT,
// * ລາຍງານມອບເງິນປັນຜົນ : DIVIDEND_DISTRIBUTION_REPORT,

// Document type constants
export const DOC_TYPES = {
    OPERATION_PLAN: "OPERATION_PLAN",

    TAX_OBLIGATION_PLAN: "TAX_OBLIGATION_PLAN",
    DIVIDEND_DISTRIBUTION_PLAN: "DIVIDEND_DISTRIBUTION_PLAN",

    ASSET_REPORT: "ASSET_REPORT",
    DEBT_REPORT: "DEBT_REPORT",
    CASH_FLOW_DERIRECT_REPORT: "CASH_FLOW_DERIRECT_REPORT",
    CASH_FLOW_RETURN_REPORT: "CASH_FLOW_RETURN_REPORT",
    FINANCIAL_REPORT: "FINANCIAL_REPORT",
    OWNER_EQUITY_CHANGE_REPORT: "OWNER_EQUITY_CHANGE_REPORT",
    FIX_ASSET_REPORT: "FIX_ASSET_REPORT",
    INDICATOR_REPORT: "INDICATOR_REPORT",

    TAX_OBLIGATION_REPORT: "TAX_OBLIGATION_REPORT",
    DIVIDEND_DISTRIBUTION_REPORT: "DIVIDEND_DISTRIBUTION_REPORT",
} as const;

export const useDocumentByType = () => {
    const { documents } = useDocumentStore();

    // Helper function to get document by type
    const getDocument = (documentType: string): Document | undefined => {
        return documents?.find((doc: Document) => doc.documentType === documentType);
    };

    // Helper function to get all documents by type
    const getDocuments = (documentType: string): Document[] => {
        return documents?.filter((doc: Document) => doc.documentType === documentType) || [];
    };

    // Easy-to-use variables for each document type
    const operationReport = getDocument(DOC_TYPES.OPERATION_PLAN);

    const taxObligationPlan = getDocument(DOC_TYPES.TAX_OBLIGATION_PLAN);
    const dividendDistributionPlan = getDocument(DOC_TYPES.DIVIDEND_DISTRIBUTION_PLAN);

    const assetReport = getDocument(DOC_TYPES.ASSET_REPORT);
    const debtReport = getDocument(DOC_TYPES.DEBT_REPORT);
    const cashFlowDerirectReport = getDocument(DOC_TYPES.CASH_FLOW_DERIRECT_REPORT);
    const cashFlowReturnReport = getDocument(DOC_TYPES.CASH_FLOW_RETURN_REPORT);
    const financialReport = getDocument(DOC_TYPES.FINANCIAL_REPORT);
    const ownerEquityChangeReport = getDocument(DOC_TYPES.OWNER_EQUITY_CHANGE_REPORT);
    const fixAssetReport = getDocument(DOC_TYPES.FIX_ASSET_REPORT);
    const indicatorReport = getDocument(DOC_TYPES.INDICATOR_REPORT);

    const taxObligationReport = getDocument(DOC_TYPES.TAX_OBLIGATION_REPORT);
    const dividendDistributionReport = getDocument(DOC_TYPES.DIVIDEND_DISTRIBUTION_REPORT);

    return {
        // Simple access to all document types
        operationReport,
        dividendDistributionPlan,
        assetReport,
        cashFlowDerirectReport,
        debtReport,
        cashFlowReturnReport,
        taxObligationReport,
        ownerEquityChangeReport,
        financialReport,
        fixAssetReport,
        indicatorReport,
        taxObligationPlan,
        dividendDistributionReport,

        // Helper functions for custom queries
        getDocument,
        getDocuments,
    };
};